import { Grid } from "@mui/material";
import { Ticket } from "models/customer-supports/Ticket";

const MDInput = require("components/MDInput").default;

export const TicketRelated = ({ ticket, setTicket }: { ticket: Ticket; setTicket: any }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <MDInput
          fullWidth
          label="Profile ID"
          value={ticket.reportee}
          onChange={(e: any) => {
            setTicket({ ...ticket, reportee: e.target.value });
          }}
        />
      </Grid>
      <Grid size={6}>
        <MDInput
          fullWidth
          label="Introduction ID"
          value={ticket.introductionId}
          onChange={(e: any) => {
            setTicket({ ...ticket, introductionId: e.target.value });
          }}
        />
      </Grid>
    </Grid>
  );
};
